module.exports = "//static.hsappstatic.net/collaboration-sidebar/static-1.46974/images/CommentIndicatorPointerFlint.svg"